import { gql } from '@apollo/client';

export const FETCH_ALL_BILLS = gql`
  query fetchAllBills(
    $sortOrder: SortOrder!
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllBills(
      sortOrder: $sortOrder
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      unPaidBills {
        billId
        date
        providerName
        totalDue
        status
        serviceType
        paymentStatus
      }
      paidBills {
        billId
        date
        status
        serviceType
        providerName
        totalDue
        paymentStatus
      }
      totalBills
    }
  }
`;

export const GET_METADATA = gql`
  query billSummary ($sourceUrl: String) {
    billSummary (sourceUrl: $sourceUrl) {
      totalDue
      totalSpent
      totalDueBills
      totalExpenditureBills
    }
  }
`;

export const FETCH_BILL_DETAILS = gql`
  query fetchBillInfo($billId: String!) {
    fetchBillInfo(billId: $billId) {
      status
      copayAmount
      paidByPlanAmount
      promoCodeAmount
      paidAmount
      patientId
      patientName
      providerName
      serviceDate
      paidDate
      serviceType
      paymentDetail {
        identifierName
        identifierId
        amount
        currency
      }
      awardPointsToDollar
      totalDue
      paymentType
      last4
      paymentStatus
    }
  }
`;

export const FETCH_DUE_BILLS = gql`
  query fetchBillsByDueDay($dueDays: Int) {
    fetchBillByDueDay(dueDays: $dueDays) {
      totalDueDays
      status
      totalDueBills
    }
  }
`;
